module.exports = __webpack_public_path__ + "static/Casino-8fd06acb32941c44db98ea0599f751eb.jpg";